import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import { getConditionResult, getOffersLength } from '../../../utils/rule-builder-util'
import { ContentType, RuleType } from '../../../utils/types'
import { ContentFragment, ReactTeaserCardsProps } from '../types'

const ReactTeaserCard = (props: ReactTeaserCardsProps): JSX.Element => {
  const { contentFragments, ruleExpression = '', ruleType, condition, contentType, maxSlides, renderCard } = props
  const flexOffers = useFlexOffers(ruleExpression)
  const offersLength = getOffersLength(maxSlides, flexOffers)

  if (contentType === ContentType.copy) {
    const cfItem = contentFragments[0]
    for (let i = 1; i < offersLength; i++) {
      contentFragments.push(cfItem)
    }
  }

  return (
    <>
      {contentFragments.length > 0 &&
        contentFragments.map((item: ContentFragment, index: number) => {
          const elements = item?.elements || {}
          const id = item?.id
          let conditionResult = true
          if (flexOffers?.success && ruleType === RuleType.conditional && condition) {
            conditionResult = getConditionResult(condition, flexOffers, index)
          }
          if (conditionResult) {
            if (
              contentType === ContentType.static ||
              (contentType === ContentType.dynamic && index < offersLength) ||
              (contentType == ContentType.copy && index < offersLength)
            ) {
              return renderCard(elements, index, id)
            }
            return null
          }
        })}
    </>
  )
}
export default ReactTeaserCard
